






















































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import "v-credit-card/dist/VCreditCard.css";
import VCreditCard from "v-credit-card";
import fitty from "fitty";
import RequestHandler from "@/assets/ts/requestHandler";
const requestHandler = new RequestHandler();
@Component({
  components: {
    VCreditCard
  }
})
export default class Pay extends Vue {
  @Prop({ required: true }) amount!: number;
  @Prop({ required: true }) saveItems!: any;
  @Prop({ required: true }) payType!: string;
  isEMVDevice = false;
  cardType = "";
  manualCard = {
    name: "",
    cardNumber: "",
    expiration: "",
    security: "",
    zip: "",
    street: "",
    type: ""
  };
  manualVerifyLoading = false;
  creditCardImageMap = {
    cc_visa: require("@/assets/images/visa.svg"),
    cc_mc: require("@/assets/images/mastercard.svg"),
    cc_disc: require("@/assets/images/discover.svg"),
    cc_amex: require("@/assets/images/amex.svg")
  };
  cardStatusMap = {
    default: "Please wait...",
    swipeMSR: "Swipe Card",
    decline: "Card declined. Please try again.",
    deviceLoading: "Please wait for device...",
    CARD_IST: "Please Insert, Swipe, or Tap Card",
    CARD_IS: "Please Insert or Swipe Card",
    CARD_I: "Please Insert or Swipe Card",
    CARD_S: "Swipe Card",
    CANCEL: "Cancelling. Please wait...",
    REMOVECARD: "Please Remove Card",
    BAD_INSERT: "Bad insert. Please try again.",
    CHIP_CARD_SWIPED: "Chip card swiped. Please insert card.",
    BAD_SWIPE: "Bad swipe. Please try again.",
    MONETRA: "Preparing device...",
    DEVICEOPEN: "Preparing device...",
    saving: "Completing transaction. Please wait..."
  };
  cardStatus: any = "deviceLoading";
  currentDeviceStatus: any = {};
  connectedDevices: any;
  checkDeviceStatus = false;
  unitermFinished = false;
  transactionComplete = false;
  chargeIsLoading = false;
  options: {
    minSize: number;
    maxSize: number;
    multiLine: boolean;
  } = {
    minSize: 1,
    maxSize: 45,
    multiLine: false
  };
  totalShow: any = {
    credit: false,
    debit: false,
    both: false,
    ctransition: false,
    dtransition: false
  };
  barcodeRaw = "";
  scanning = false;
  barcodeTimeout = 0;
  cardInfo = {
    issuer_bank: "",
    cardType: "",
    transactionType: "",
    monetraResponse: {} as any,
    confirmFunction: {} as Function
  };
  showConfirm = false;
  creditFee: any = 0;
  debitFee: any = 0;
  creditTransactions: any = [];
  debitTransactions: any = [];
  pTranNum = NaN;

  get manualInfoValidated(): boolean {
    if (this.payType !== "manual") return true;
    let validated = true;
    try {
      Object.keys(this.manualCard).forEach((key: string) => {
        if (
          ["", null, undefined].includes((this.manualCard as any)[key]) &&
          key !== "type"
        ) {
          throw "blank value";
        }
      });
      if (this.manualCard.cardNumber.length < 16)
        throw "cardnum not long enough";

      if (
        this.manualCard.security.length < 3 &&
        this.manualCard.type !== "Amex"
      )
        throw "cvv not long enough";

      if (this.manualCard.security.length < 4 && this.manualCard.type == "Amex")
        throw "cvv not long enough";

      if (this.manualCard.expiration.length < 4)
        throw "expiration not long enough";

      if (this.manualCard.zip.length < 5) throw "zip not long enough";
    } catch (e) {
      validated = false;
    }
    return validated;
  }

  manualCardInfoChanged(info: any) {
    Object.assign(this.manualCard, info);
  }

  manualCardTypeChanged(cardType: string) {
    this.manualCard.type = cardType;
  }

  resizeText() {
    this.$nextTick(() => {
      if (this.$refs.fitText != undefined)
        fitty(this.$refs.fitText as HTMLElement, this.options);
      if (this.$refs.fitText1 != undefined)
        fitty(this.$refs.fitText1 as HTMLElement, this.options);
      if (this.$refs.fitText2 != undefined)
        fitty(this.$refs.fitText2 as HTMLElement, this.options);
    });
  }

  @Watch("cardType")
  cardTypeChange() {
    if (this.totalShow.both) return;
    if (this.cardType === "") {
      Object.assign(this.totalShow, { credit: true, debit: true });
      this.resizeText();
      return;
    }
    const hide = ["credit", "debit"].filter(e => e !== this.cardType)[0];
    const transition = `${this.cardType.charAt(0)}transition`;
    this.totalShow[this.cardType] = this.totalShow[transition] = true;
    setTimeout(() => {
      this.totalShow[transition] = this.totalShow[hide] = false;
      this.resizeText();
    }, 500);
  }

  async calculateFees() {
    try {
      const response: {
        credit: number;
        debit: number;
        creditTransactions: any;
        debitTransactions: any;
      } = (await requestHandler.call({
        action: "calculateFees",
        transactions: this.saveItems
      })) as any;

      if (this.$store.getters.userInfo.chargeFees !== false) {
        //doing a reverse here so by default fees are charged
        this.creditFee = response.credit;
        this.debitFee = response.debit;
      }

      this.creditTransactions = response.creditTransactions;
      this.debitTransactions = response.debitTransactions;
    } catch (e) {
      console.error(e);
      this.$root.$emit("snackbar-message", {
        text: "Unable to get fees.",
        color: "red"
      });
      this.$emit("close");
    }
  }

  get amountToCharge() {
    return this.cardType === "debit"
      ? this.debitFee + this.amount
      : this.creditFee + this.amount;
  }

  get acceptedCards() {
    const cardArr: Array<any> = [];
    ["cc_visa", "cc_mc", "cc_disc", "cc_amex"].forEach((card: string) => {
      if (this.$store.getters.userInfo[card] === "Y") cardArr.push(card);
    });
    return cardArr;
  }

  async created() {
    if (this.payType === "manual") {
      this.$nextTick(() => {
        //change maxlength of name field
        document.getElementById("name")?.setAttribute("maxlength", "50");

        //force clear credit card form
        Object.assign((this.$refs.cardForm as any).form, {
          name: "",
          cardNumber: "",
          expiration: "",
          security: ""
        });

        //only allow 4 chars on amex
        (this.$refs.cardForm as any).$refs.security.onkeydown = (
          event: any
        ) => {
          if (
            (this.$refs.cardForm as any).$refs.security.value.length == 3 &&
            this.manualCard.type !== "Amex" &&
            !["Backspace", "Delete", "Tab"].includes(event.code)
          ) {
            event.preventDefault();
          }
        };
      });
    }
    try {
      this.pTranNum = (
        await requestHandler.call({
          action: "getPTranNumber"
        })
      )[0].ptrannumber;
      if (isNaN(parseFloat(this.pTranNum as any)) || !isFinite(this.pTranNum))
        throw "no ptrann";
    } catch (e) {
      console.error(e);
      this.$root.$emit("snackbar-message", {
        text: "There was a problem with the server.",
        color: "red"
      });
      this.$emit("close");
      return;
    }
    await this.calculateFees();
    const usrInfo = this.$store.getters.userInfo;
    if (
      (usrInfo.flatRateCredit === "N" && usrInfo.flatRateDebit === "N") ||
      (usrInfo.flatRateDebit == undefined &&
        usrInfo.flatRateCredit == undefined)
    )
      this.totalShow.both = true;
    else Object.assign(this.totalShow, { credit: true, debit: true });

    try {
      await requestHandler.setHubAppMonetraCreds();
    } catch (e) {
      console.error(e);
      this.$root.$emit("snackbar-message", {
        text: "There was a problem with the hub app.",
        color: "red"
      });
      this.$emit("close");
      return;
    }

    if (this.payType == "swipe") {
      this.initSwipe();
    }
  }

  async initSwipe() {
    this.connectedDevices = (
      await requestHandler.getConnectedDevices()
    ).connectedDevices;

    this.isEMVDevice = this.connectedDevices.length > 0;

    if (this.isEMVDevice) {
      try {
        const params = {
          u_action: "cancel",
          Action: "Sale",
          u_id: "42",
          nsf: "no",
          u_device: this.connectedDevices[0].u_device,
          u_devicetype: this.connectedDevices[0].u_devicetype,
          u_flags: "DEVICEONLY"
        };
        await requestHandler.queryUniterm(params);
      } catch (e) {
        console.error(e);
      }
      this.cardStatus = "deviceLoading";
      try {
        this.checkDeviceStatus = true;
        this.startDeviceStatusHandler();
        this.startChargeUniterm().then(response => {
          if (response.Resp.code == "CANCEL") {
            this.cardStatus = "CANCEL";
            this.$root.$emit("snackbar-message", {
              text: "The transaction was cancelled.",
              color: "red"
            });
            this.$emit("close");
            return;
          }
          this.checkDeviceStatus = false;
          this.parseCardInfo(response);
          this.cardInfo.confirmFunction = this.finishChargeUniterm;
        });
      } catch (e) {
        console.error(e);
      }
    } else {
      this.cardStatus = "swipeMSR";
      window.addEventListener("keydown", this.keyboardScanner);
    }
    this.resizeText();
  }

  filterNumber(event: any) {
    if (["e", "+", "-", "."].includes(event.key)) {
      event.preventDefault();
    }
  }

  filterZip(event: any) {
    this.filterNumber(event);
    if (
      this.manualCard.zip.length === 5 &&
      !["Backspace", "Delete", "Tab"].includes(event.code)
    ) {
      event.preventDefault();
    }
  }

  keyboardScanner(event: any) {
    if (["Control", "Shift", "Alt"].includes(event.key)) {
      // if key is ctrl, shift, or alt
      return;
    }

    if (event.ctrlKey && this.scanning) {
      event.preventDefault();
      return;
    }
    if (
      event.key == "Enter" &&
      event.target == document.body &&
      this.scanning
    ) {
      // keyCode 32 is space
      event.preventDefault();
    }
    this.scanning = true;

    const scanWaitTime = 100;
    if (event.key == "-") {
      // if key is '-'
      this.barcodeRaw += "-";
    } else if (event.key !== "Enter") {
      // ignore endlines
      this.barcodeRaw += event.key;
    }

    clearTimeout(this.barcodeTimeout);
    this.barcodeTimeout = setTimeout(() => {
      //unencrypted keyboard mode
      let match = /^%B[0-9]{16}\^/.exec(this.barcodeRaw);
      if (match !== null) {
        this.unencrypedKeyboardSwipe(this.barcodeRaw);
      }
      match = /;[0-9]{6}\*{4,}[0-9]{4}=/.exec(this.barcodeRaw);
      if (match !== null) {
        this.encrypedKeyboardSwipe(this.barcodeRaw);
      }

      this.barcodeRaw = "";
      this.scanning = false;
    }, scanWaitTime);
  }

  async encrypedKeyboardSwipe(cardString: string) {
    try {
      const response = await requestHandler.getTicket({
        isHID: false,
        trackdata: cardString
      });
      this.parseCardInfo(response.data);
      this.cardInfo.confirmFunction = this.chargeTicket;
    } catch (e) {
      this.$root.$emit("snackbar-message", {
        text: "Unable to read card.",
        color: "red"
      });
      console.error(e);
    }
  }

  async unencrypedKeyboardSwipe(cardString: string) {
    try {
      const params = {
        Action: "cardtype",
        trackdata: cardString
      };
      const response = await requestHandler.queryMonetra(params);
      this.parseCardInfo(response);
      this.cardInfo.confirmFunction = this.chargeTicket;
    } catch (e) {
      this.$root.$emit("snackbar-message", {
        text: "Unable to read card.",
        color: "red"
      });
      console.error(e);
    }
  }

  parseCardInfo(cardInfo: any) {
    if (cardInfo.Resp.code !== "AUTH") {
      this.$root.$emit("snackbar-message", {
        text: "The charge was unsuccessful.<br/>" + cardInfo.Resp.verbiage,
        color: "red"
      });
      this.$emit("close");
      return;
    }
    this.cardInfo.monetraResponse = cardInfo;
    if (
      cardInfo.Resp.card_cardclass === "DEBIT" ||
      cardInfo.Resp.u_cardclass == "DEBIT"
    )
      this.cardType = "debit";
    else this.cardType = "credit";
    this.cardStatus = undefined;
    this.cardInfo.cardType = cardInfo.Resp.cardtype;
    this.cardInfo.issuer_bank =
      cardInfo.Resp.card_issuer_bank || cardInfo.Resp.rcpt_emv_name || "";
    this.showConfirm = true;
  }

  @Watch("$store.getters.hubAppEvent")
  async hubAppEventChanged() {
    if (this.$store.getters["hubAppEvent"].action == "deviceInput") {
      const monetraResp = this.$store.getters["hubAppEvent"].data;
      if (
        monetraResp.Resp == undefined ||
        monetraResp.Resp.ticket == undefined
      ) {
        this.cardStatus = "decline";
        setTimeout(() => {
          this.cardStatus = "swipeMSR";
        }, 1000);
      } else {
        this.parseCardInfo(monetraResp);
        this.cardInfo.confirmFunction = this.chargeTicket;
      }
    }
  }

  async destroyed() {
    if (!this.transactionComplete) {
      await requestHandler.call({
        action: "cancelPTranNumber",
        ptran: this.pTranNum
      });
    }
    window.removeEventListener("keydown", this.keyboardScanner);
    if (this.isEMVDevice) {
      this.checkDeviceStatus = false;
      this.cancelCharge();
    }
  }

  async cancelCharge() {
    if (this.isEMVDevice && !this.unitermFinished) {
      this.cardStatus = "CANCEL";
      const params = {
        u_action: "cancel",
        Action: "Sale",
        u_id: "42",
        nsf: "no",
        u_device: this.connectedDevices[0].u_device,
        u_devicetype: this.connectedDevices[0].u_devicetype,
        u_flags: "DEVICEONLY"
      };
      await requestHandler.queryUniterm(params);
    }
  }

  async manualGetCardInfo(): Promise<any> {
    try {
      this.manualVerifyLoading = true;
      const params = {
        u_action: "txnrequest",
        Action: "Admin",
        Admin: "cardshieldticket",
        account: this.manualCard.cardNumber.replaceAll(" ", ""),
        cardpresent: "no",
        expdate: this.manualCard.expiration.replace("/", ""),
        zip: this.manualCard.zip,
        cardholdername: this.manualCard.name,
        cv: this.manualCard.security,
        street: this.manualCard.street,
        pTranNum: this.pTranNum
      };
      const response = await requestHandler.queryMonetra(params);
      this.parseCardInfo(response);
      this.cardInfo.confirmFunction = this.chargeTicket;
      this.showConfirm = true;
    } catch (e) {
      console.error(e);
    } finally {
      this.manualVerifyLoading = false;
    }
  }

  async chargeTicket(amount: number): Promise<any> {
    if (this.chargeIsLoading) return;
    this.chargeIsLoading = true;
    const comment = `${this.$store.getters.userInfo.Service}/${this.$store.getters.userInfo.ServiceID}`;
    const params = {
      u_action: "txnrequest",
      Action: "Sale",
      nsf: "no",
      cardpresent: this.payType === "manual" ? "no" : "yes",
      Amount: amount.toFixed(2),
      Tax: parseFloat((amount * 0.05).toFixed(2)),
      CardShieldTicket: this.cardInfo.monetraResponse.Resp.ticket,
      Comments: comment,
      stationid: this.$store.getters.userInfo.UserID,
      clerkID: this.$store.getters.userInfo.CountyID,
      duplcheck: true,
      pTranNum: this.pTranNum
    };
    let response;
    try {
      response = await requestHandler.queryMonetra(params);
    } catch (e) {
      this.$root.$emit("snackbar-message", {
        text: "The charge was unsuccessful.",
        color: "red"
      });
      this.$emit("close");
      return;
    }
    if (
      response.Resp != undefined &&
      response.Resp.code.toUpperCase() == "AUTH"
    ) {
      await this.saveTransaction(response);
    } else {
      this.cardStatus = "decline";
      this.$root.$emit("snackbar-message", {
        text: "The charge was unsuccessful.<br/>" + response.Resp.verbiage,
        color: "red"
      });
      this.$emit("close");
    }
  }

  async startChargeUniterm() {
    const params = {
      u_action: "txnstart",
      Action: "Sale",
      u_id: "42",
      nsf: "no",
      timeout: 30,
      u_device: this.connectedDevices[0].u_device,
      u_devicetype: this.connectedDevices[0].u_devicetype,
      stationid: this.$store.getters.userInfo.UserID,
      clerkID: this.$store.getters.userInfo.CountyID,
      u_flags: "DEVICEONLY",
      ordernum: this.$store.getters.userInfo.CountyID,
      ptrannum: this.pTranNum
    };
    return await requestHandler.queryUniterm(params);
  }

  async finishChargeUniterm(amount: number) {
    if (this.chargeIsLoading) return;
    this.chargeIsLoading = true;
    const comment = `${this.$store.getters.userInfo.Service}/${this.$store.getters.userInfo.ServiceID}`;

    const params = {
      u_action: "txnfinish",
      Action: "Sale",
      u_id: "42",
      nsf: "no",
      Amount: amount.toFixed(2),
      timeout: 30,
      Tax: parseFloat((amount * 0.05).toFixed(2)),
      Comments: comment,
      u_device: this.connectedDevices[0].u_device,
      u_devicetype: this.connectedDevices[0].u_devicetype,
      stationid: this.$store.getters.userInfo.UserID,
      clerkID: this.$store.getters.userInfo.CountyID,
      duplcheck: true,
      u_flags: "DEVICEONLY",
      ordernum: this.$store.getters.userInfo.CountyID,
      ptrannum: this.pTranNum
    };
    let response;
    try {
      response = await requestHandler.queryUniterm(params);
    } catch (e) {
      this.$root.$emit("snackbar-message", {
        text: "The charge was unsuccessful.",
        color: "red"
      });
      this.$emit("close");
      return;
    }
    this.unitermFinished = true;
    if (response.Resp.code == "CANCEL") {
      this.cardStatus = "CANCEL";
      this.$root.$emit("snackbar-message", {
        text: "The transaction was cancelled.",
        color: "red"
      });
      this.$emit("close");
    } else if (
      response.Resp != undefined &&
      response.Resp.code.toUpperCase() == "AUTH"
    ) {
      this.saveTransaction(response);
    } else {
      this.cardStatus = "decline";
      this.$root.$emit("snackbar-message", {
        text: "The charge was unsuccessful.<br/>" + response.Resp.verbiage,
        color: "red"
      });
      this.$emit("close");
    }
  }

  async saveTransaction(monetraResponse: any) {
    this.transactionComplete = true;
    try {
      const cartItems = JSON.parse(
        JSON.stringify(
          this.cardType === "debit"
            ? this.debitTransactions
            : this.creditTransactions
        )
      );
      const paymentInfo = {
        payorName: monetraResponse.Resp.cardholdername || "",
        address: this.manualCard.street,
        method: this.cardType,
        zipCode: this.manualCard.zip,
        account: monetraResponse.Resp.account,
        expDate: this.cardInfo.monetraResponse.Resp.expdate || "",
        cardType: monetraResponse.Resp.cardtype,
        authNum: monetraResponse.Resp.auth,
        ttid: monetraResponse.Resp.ttid,
        batchId: monetraResponse.Resp.batch
      };
      cartItems.forEach((item: any) => {
        Object.assign(item, paymentInfo);
      });
      const response = await requestHandler.call({
        action: "storePayment",
        transactions: cartItems,
        ptran: this.pTranNum
      });
      if (
        (response.success == undefined ||
          !response.success ||
          response.paymentId == undefined) &&
        (response.reversed == undefined || !response.reversed)
      ) {
        throw "did not save, try to reverse";
      } else if (
        (response.success == undefined ||
          !response.success ||
          response.paymentId == undefined) &&
        response.reversed
      ) {
        this.$root.$emit("snackbar-message", {
          text:
            "There was a problem saving the transaction, the charge has been reversed.",
          color: "red"
        });
        this.$emit("close");
      } else {
        this.$emit("close");
        this.$emit("finishTrans", response);
      }
    } catch (e) {
      console.error(e);
      try {
        await this.reverseOrVoid(this.pTranNum);
        this.$root.$emit("snackbar-message", {
          text:
            "There was a problem saving the transaction, the charge has been reversed.",
          color: "red"
        });
        this.$emit("close");
      } catch (e) {
        //worst case scenario, we took money, did not save, could not reverse or void
        console.error(e);
        this.$root.$emit("dialog-message", {
          text:
            "There was a problem saving the transaction, and the charge could not be reversed. Please contact support to fix."
        });
        this.$emit("close");
      }
    }
  }

  async reverseOrVoid(ptrannum: number) {
    const params = {
      Action: "Reversal",
      ptrannum: ptrannum
    };
    let status = await requestHandler.queryMonetra(params);
    if (status.Resp.code == "AUTH") return status;
    else {
      const params = {
        Action: "Void",
        ptrannum: ptrannum
      };
      status = await requestHandler.queryMonetra(params);
      if (status.Resp.code == "AUTH") return status;
      else {
        return Promise.reject("could not be voided");
      }
    }
  }

  startDeviceStatusHandler() {
    if (this.checkDeviceStatus) {
      this.getDeviceStatus().then(() => {
        window.setTimeout(() => {
          this.startDeviceStatusHandler();
        }, 1000);
      });
    }
  }

  async getDeviceStatus(): Promise<void> {
    const params = {
      u_action: "status",
      u_id: "42",
      u_flags: "DEVICEONLY"
    };
    const status = await requestHandler.queryUniterm(params, 1000);
    if (status.Resp != undefined && status.Resp.u_status != undefined)
      this.cardStatus = status.Resp.u_status;
    else this.cardStatus = "deviceLoading";
    Object.assign(this.currentDeviceStatus, {}, status);
  }
}
